import {
  GET_ORDERS_LIST,
  ERROR_ORDERS,
  SCROLL_ON_ORDERS,
  GET_ORDER,
  GET_PRODUCTS_LIST,
  MESSAGE_ORDERS,
  EXPORT_ORDERS,
  VALIDATE_ORDER,
  SET_ORDERS_FILTERS,
  DELETE_ORDER,
  GET_ORDERS_FILTERED,
} from "../actions/types"

const initialState = {
  ordersList: [],
  order: {},
  error: {},
  lists: null,
  scrollOrders: 0,
  message: {},
  products: [],
  exportList : null,
  filters: {
    search: "",
    magasins: [],
    fournisseurs:[],
    page:1,
    orderBy: {
      key: "magasinName",
      order: "asc"
    },
    number: 20,
  },
};

export default function ordersReducer(state = initialState, action) {
  let ordersList = state.ordersList;
  switch (action.type) {
    case MESSAGE_ORDERS:
      return {...state, message : action.payload.message }
    case EXPORT_ORDERS:
      return {...state, exportList : action.payload}
    case SET_ORDERS_FILTERS:
      return {...state, filters : {...state.filters, ...action.payload }}
    case VALIDATE_ORDER:
      return {...state, order : {...state.order , status: "confirmed" } , message: action.payload.message }
    case DELETE_ORDER:
      return {...state, offersList: state.ordersList.filter((o) => o._id !== action.payload)}
    case GET_ORDER:
      return {...state, order : action.payload}
    case GET_ORDERS_FILTERED:
      if (state.filters.page > 1) {
        ordersList = [...ordersList,...action.payload];
      } else {
        ordersList = [...action.payload];
      }
      return {...state, ordersList}
    case GET_PRODUCTS_LIST:
      return {...state, productsList : action.payload}
    case GET_ORDERS_LIST:
      return {...state, lists : action.payload}
    case ERROR_ORDERS:
        return {...state, error: action.payload}
    case SCROLL_ON_ORDERS:
      return {...state, scrollOrders: action.payload}
    default:
      return {...state};
  }
}
